export const MESSAGE_GROUP_PARTS = [
  'container',
  'userMessage',
  'agentMessageContent',
] as const;
